import { CommonBadgeProps } from '@/types';

import styles from './DotBadge.module.scss';

export const DotBadge = ({ background, border, size }: CommonBadgeProps): React.JSX.Element => {
  const computedStyle = [
    styles.container,
    styles[size],
    background,
    border
  ].filter(Boolean).join(' ');

  return (
    <div className={computedStyle} data-test-id="dot-badge" />
  );
};

export default DotBadge;
